import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, unref as _unref, renderList as _renderList, createBlock as _createBlock, toDisplayString as _toDisplayString, resolveDynamicComponent as _resolveDynamicComponent, KeepAlive as _KeepAlive } from "vue"

import { ref, watch, computed, onMounted } from 'vue'
import { useStore } from 'vuex'
import { useRouter, useRoute } from 'vue-router'
import Breadcrumbs from '@/components/Breadcrumbs.vue'
import { menu as menuData } from '@/data/menu'


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const drawer = ref(true)
const menu = menuData
const openGroups = ref<Record<number, boolean>>({})
const store = useStore()
const router = useRouter()
const route = useRoute()

const snackbar = computed(() => store.state.Ui.snackbar)
const estado = computed(() => store.state.Ui.status)
const tabs = computed(() => store.getters['tabs/tabs'])
const activeTab = computed(() => store.getters['tabs/activeTab'])
const cachedViews = computed(() => store.getters['tabs/cachedViews'])

const activeTabIndex = computed({
  get: () => activeTab.value,
  set: (value) => store.dispatch('tabs/setActiveTab', value)
})

// Restaurar tabs al montar el componente
onMounted(() => {
  // Los tabs ya se cargan desde localStorage en el state inicial
  // Solo necesitamos navegar a la ruta activa si es diferente
  const activeRoute = store.getters['tabs/activeTabRoute']
  
  if (route.path !== activeRoute && activeRoute !== '/login') {
    router.push(activeRoute)
  }
})

function generateTabId(route: string): string {
  return route.replace(/\//g, '-').substring(1) || 'dashboard'
}

function findMenuItemByRoute(path: string): any {
  for (const item of menu) {
    if (item.to === path) {
      return item
    }
    if (item.children) {
      const child = item.children.find((c: any) => c.to === path)
      if (child) return child
    }
  }
  return null
}

function openTabFromMenu(menuItem: any) {
  const tabId = generateTabId(menuItem.to)
  const tab = {
    id: tabId,
    title: menuItem.title,
    route: menuItem.to,
    icon: menuItem.icon,
    closable: menuItem.to !== '/dashboard',
    componentName: menuItem.componentName
  }
  
  store.dispatch('tabs/openTab', tab)
  router.push(menuItem.to)
}

function switchTab(tabId: string) {
  const tab = tabs.value.find((t: any) => t.id === tabId)
  if (tab) {
    store.dispatch('tabs/setActiveTab', tabId)
    router.push(tab.route)
  }
}

function closeTab(tabId: string) {
  const currentTabs = tabs.value
  const tabToClose = currentTabs.find((t: any) => t.id === tabId)
  
  if (!tabToClose || !tabToClose.closable) return
  
  store.dispatch('tabs/closeTab', tabId)
  
  const newActiveTab = store.getters['tabs/activeTabRoute']
  if (route.path !== newActiveTab) {
    router.push(newActiveTab)
  }
}

function toggleGroup(index: number) {
  for (const key in openGroups.value) {
    openGroups.value[key] = false
  }
  openGroups.value[index] = true
}

watch(() => route.path, (newPath) => {
  // Ignorar login
  if (newPath === '/login') return
  
  const tabId = generateTabId(newPath)
  const existingTab = tabs.value.find((t: any) => t.id === tabId)
  
  if (!existingTab) {
    const menuItem = findMenuItemByRoute(newPath)
    
    const tab = {
      id: tabId,
      title: menuItem?.title || 'Página',
      route: newPath,
      icon: menuItem?.icon,
      closable: newPath !== '/dashboard',
      componentName: menuItem?.componentName
    }
    
    store.dispatch('tabs/openTab', tab)
  } else if (existingTab) {
    store.dispatch('tabs/setActiveTab', tabId)
  }
})

watch(estado, () => {
  if (estado.value.codeStatus === 401) {
    logout()
  }
})

function goToProfile() {
  console.log('GO TO PERFIL')
}

function goToSettings() {
  console.log('GO TO CONFIGURATION')
}

function logout() {
  localStorage.removeItem('token')
  localStorage.removeItem('tabs-state') // Limpiar tabs guardados
  store.dispatch('tabs/clearTabs')
  router.push('/login')
}

function closeOtherTabs() {
  const currentTabs = [...tabs.value]
  const activeTabId = activeTab.value
  
  currentTabs.forEach((tab: any) => {
    if (tab.id !== activeTabId && tab.closable) {
      store.dispatch('tabs/closeTab', tab.id)
    }
  })
}

function closeAllTabs() {
  const currentTabs = [...tabs.value]
  
  currentTabs.forEach((tab: any) => {
    if (tab.closable) {
      store.dispatch('tabs/closeTab', tab.id)
    }
  })
  
  router.push('/dashboard')
}

return (_ctx: any,_cache: any) => {
  const _component_v_app_bar_nav_icon = _resolveComponent("v-app-bar-nav-icon")!
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!
  const _component_v_list_group = _resolveComponent("v-list-group")!
  const _component_v_navigation_drawer = _resolveComponent("v-navigation-drawer")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_v_layout = _resolveComponent("v-layout")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_layout, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_app_bar, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_app_bar_nav_icon, {
                variant: "text",
                onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (drawer.value = !drawer.value), ["stop"]))
              }),
              _createVNode(_component_v_toolbar_title, null, {
                default: _withCtx(() => _cache[5] || (_cache[5] = [
                  _createTextVNode("ADMINISTRACIÓN")
                ])),
                _: 1,
                __: [5]
              }),
              (_ctx.$vuetify.display.mdAndUp)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createVNode(_component_v_btn, {
                      icon: "mdi-magnify",
                      variant: "text"
                    }),
                    _createVNode(_component_v_btn, {
                      icon: "mdi-filter",
                      variant: "text"
                    })
                  ], 64))
                : _createCommentVNode("", true),
              _createVNode(_component_v_menu, { location: "bottom end" }, {
                activator: _withCtx(({ props }) => [
                  _createVNode(_component_v_btn, _mergeProps({
                    icon: "mdi-dots-vertical",
                    variant: "text"
                  }, props), null, 16)
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_v_list, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_list_item, { onClick: closeOtherTabs }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item_title, null, {
                            default: _withCtx(() => _cache[6] || (_cache[6] = [
                              _createTextVNode("Cerrar otras pestañas")
                            ])),
                            _: 1,
                            __: [6]
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_list_item, { onClick: closeAllTabs }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item_title, null, {
                            default: _withCtx(() => _cache[7] || (_cache[7] = [
                              _createTextVNode("Cerrar todas las pestañas")
                            ])),
                            _: 1,
                            __: [7]
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_divider),
                      _createVNode(_component_v_list_item, { onClick: logout }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item_title, { class: "text-red" }, {
                            default: _withCtx(() => _cache[8] || (_cache[8] = [
                              _createTextVNode("Cerrar sesión")
                            ])),
                            _: 1,
                            __: [8]
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_navigation_drawer, {
            app: "",
            modelValue: drawer.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((drawer).value = $event)),
            clipped: "",
            location: _ctx.$vuetify.display.mobile ? 'bottom' : undefined,
            permanent: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_list, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item, {
                    "prepend-avatar": "https://this-person-does-not-exist.com/img/avatar-gencc9c6241e70d5610a787db8f337b459e.jpg",
                    subtitle: "jennifer@google.com",
                    title: "Jennifer Leider"
                  }, {
                    append: _withCtx(() => [
                      _createVNode(_component_v_btn, {
                        icon: "mdi-menu-down",
                        size: "small",
                        variant: "text"
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_divider),
              _createVNode(_component_v_list, {
                density: "compact",
                nav: ""
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(menu), (item, index) => {
                    return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                      (item.children)
                        ? (_openBlock(), _createBlock(_component_v_list_group, {
                            key: 0,
                            modelValue: openGroups.value[index],
                            "onUpdate:modelValue": [($event: any) => ((openGroups.value[index]) = $event), (val) => toggleGroup(index)],
                            "prepend-icon": item.icon
                          }, {
                            activator: _withCtx(({ props }) => [
                              _createVNode(_component_v_list_item, _mergeProps({ ref_for: true }, props, {
                                title: item.title
                              }), null, 16, ["title"])
                            ]),
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (child, i) => {
                                return (_openBlock(), _createBlock(_component_v_list_item, {
                                  key: i,
                                  onClick: ($event: any) => (openTabFromMenu(child)),
                                  title: child.title,
                                  class: "pl-6"
                                }, null, 8, ["onClick", "title"]))
                              }), 128))
                            ]),
                            _: 2
                          }, 1032, ["modelValue", "onUpdate:modelValue", "prepend-icon"]))
                        : (_openBlock(), _createBlock(_component_v_list_item, {
                            key: 1,
                            onClick: ($event: any) => (openTabFromMenu(item)),
                            title: item.title,
                            "prepend-icon": item.icon
                          }, null, 8, ["onClick", "title", "prepend-icon"]))
                    ], 64))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue", "location"]),
          _createVNode(_component_v_main, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_tabs, {
                modelValue: activeTabIndex.value,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((activeTabIndex).value = $event)),
                "bg-color": "surface",
                "show-arrows": "",
                "next-icon": "mdi-arrow-right-bold-box-outline",
                "prev-icon": "mdi-arrow-left-bold-box-outline",
                density: "default",
                "slider-color": "primary"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabs.value, (tab) => {
                    return (_openBlock(), _createBlock(_component_v_tab, {
                      key: tab.id,
                      value: tab.id,
                      onClick: ($event: any) => (switchTab(tab.id)),
                      variant: "elevated"
                    }, {
                      default: _withCtx(() => [
                        (tab.icon)
                          ? (_openBlock(), _createBlock(_component_v_icon, {
                              key: 0,
                              start: "",
                              icon: tab.icon,
                              size: "small"
                            }, null, 8, ["icon"]))
                          : _createCommentVNode("", true),
                        _createTextVNode(" " + _toDisplayString(tab.title) + " ", 1),
                        (tab.closable)
                          ? (_openBlock(), _createBlock(_component_v_btn, {
                              key: 1,
                              icon: "mdi-close",
                              size: "x-small",
                              variant: "text",
                              class: "ml-2",
                              onClick: _withModifiers(($event: any) => (closeTab(tab.id)), ["stop"])
                            }, null, 8, ["onClick"]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1032, ["value", "onClick"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_router_view, null, {
                default: _withCtx(({ Component }) => [
                  (_openBlock(), _createBlock(_KeepAlive, { include: cachedViews.value }, [
                    (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
                  ], 1032, ["include"]))
                ]),
                _: 1
              }),
              _createVNode(_component_v_snackbar, {
                modelValue: snackbar.value.show,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((snackbar.value.show) = $event)),
                color: snackbar.value.color,
                location: "bottom center"
              }, {
                actions: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    icon: "mdi-close",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (snackbar.value.show = false))
                  })
                ]),
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(snackbar.value.text) + " ", 1)
                ]),
                _: 1
              }, 8, ["modelValue", "color"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})